// extracted by mini-css-extract-plugin
module.exports = {"c1x15wja":"c1x15wja"};